import React from 'react';
import { Clock, BookOpen, Award, Briefcase } from 'lucide-react';

const StatsBar = () => {
  const stats = [
    {
      icon: <Clock size={28} color="#FF6B00" />,
      text: '100% Flexible Learning'
    },
    {
      icon: <BookOpen size={28} color="#FF6B00" />,
      text: 'Industry Relevant Curriculum'
    },
    {
      icon: <Award size={28} color="#FF6B00" />,
      text: 'At Par With On-Campus Degrees'
    },
    {
      icon: <Briefcase size={28} color="#FF6B00" />,
      text: '100% Placement Assistance'
    }
  ];

  return (
    <section className="stats-bar-section">
      <div className="stats-container">
        {stats.map((stat, idx) => (
          <React.Fragment key={idx}>
            <div className="stat-item">
              <div className="stat-icon-wrapper">{stat.icon}</div>
              <p className="stat-text">{stat.text}</p>
            </div>
            {idx < stats.length - 1 && <div className="stat-divider"></div>}
          </React.Fragment>
        ))}
      </div>
    </section>
  );
};

export default StatsBar;
